/* eslint-disable no-unused-vars */
import { useMemo, useCallback, memo } from 'react';
import { Typography, Stack } from '@mui/material';
import { ToggleBtn } from 'components';
import * as S from '../../ConversionTracking.styled';
import uuid from 'react-uuid';
import { useComputed } from '@preact/signals-react';

const Reattribution = ({ isReattribution$, onChange }) => {
  return (
    <Stack direction='row' sx={{ justifyContent: 'flex-start', gap: '8px', marginBottom: '32px' }}>
      <Typography style={S.TitleLabels}>Reattribution:</Typography>
      {useComputed(() => (
        <ToggleBtn
          isChecked={isReattribution$.value ?? false}
          onChange={onChange}
          id={`reattribution_${uuid()}`}
        />
      ))}
    </Stack>
  );
};

export default memo(Reattribution);
